module.exports = __webpack_public_path__ + "img/currencyEle.12bb19d5.svg";